import React from 'react';

// CSS for the component to mimic the 'filled' variant
const styles = {
  container: {
    fontFamily:'Ford-Normal',
    margin: '15px',
    position: 'relative',
    backgroundColor: '#f0f0f0',
    borderRadius: '4px',
    transition: 'background-color 0.3s',
    //width: "100px"
    //display: 'inline-block'
    width:"300px"
    
  },
  label: {
    position: 'absolute',
    // left: '12px',
    textAlign:"start",
    width:"100%",
    top: '-6px',
    backgroundColor: '#f0f0f0',
    padding:"3px",
    paddingLeft:"10px",
    fontSize: '0.75rem',
    color: '#888',
    transition: 'top 0.3s, font-size 0.3s',
    fontFamily:'Ford-Normal'
  },
  input: {
    width: '100%',
    padding: '18px 12px 6px',
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    fontSize: '1rem',
    fontFamily:'Ford-Normal'
  }
};

class TextField extends React.Component {
  render() {
    const { label, value, onChange } = this.props;

    return (
      <div style={styles.container}>
        <label style={styles.label}>{label}</label>
        <input
          type="text"
          value={value}
          onChange={onChange}
          style={styles.input}
        />
      </div>
    );
  }
}

export default TextField;
